export const linkIcons = (icon: string) => {
  switch (icon) {
    case 'arrowRight':
    case 'Arrow Right':
    case 'Arrow':
    case 'arrow':
    case 'Right Arrow':
      return 'arrow'
    case 'download':
    case 'Download':
      return 'download'
    case 'chevronRight':
    case 'Chevron Right':
      return 'chevron-right'
    case 'chevronDown':
    case 'Chevron Down':
      return 'chevron-down'
    default:
      return 'none'
  }
}
